import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { LayoutService } from '@app/core/services/layout.service';
import { Router } from '@angular/router';

@Component({
	selector: 'app-sign-up-callback',
	templateUrl: './sign-up-callback.component.html',
	styleUrls: ['./sign-up-callback.component.scss']
})
export class SignUpCallbackComponent {
	constructor(private layoutService: LayoutService, private router: Router) {
		this.layoutService.setPageLoading(false);
	}

	navigateToSignIn() {
		this.router.navigate(['/signIn']);
	}
}
